import * as React from 'react';
import { Footer } from '@/widgets/layouts/main/components/footer';
import { Header } from '@/widgets/layouts/main/components/header';
export interface MainLayoutProps {
  children?: React.ReactNode;
}
export const MainLayout = (props: MainLayoutProps): JSX.Element => {
  const {
    children
  } = props;
  return <>
      <Header />

      {children}

      <Footer />
    </>;
};